import { defineMessages } from 'react-intl';

const messages = defineMessages({
  description: {
    id: 'onboardingPages.clientOnboarding.basicInfoStep.description',
    defaultMessage:
      'This data will be used in purpose of recognizing your individual client profile across platform.',
  },
  email: {
    id: 'onboardingPages.clientOnboarding.basicInfoStep.email',
    defaultMessage: 'Email',
  },
  emailHelper: {
    id: 'onboardingPages.clientOnboarding.basicInfoStep.emailHelper',
    defaultMessage: '* Email you are currently logged with.',
  },
  name: {
    id: 'onboardingPages.clientOnboarding.basicInfoStep.name',
    defaultMessage: 'Name',
  },
  phone: {
    id: 'onboardingPages.clientOnboarding.basicInfoStep.phone',
    defaultMessage: 'Phone number',
  },
  title: {
    id: 'onboardingPages.clientOnboarding.basicInfoStep.title',
    defaultMessage: 'Client information',
  },
});

export default messages;
